import ProfileApis from '@/services/apis/profile'
import { convertSecondsToMinutes } from '@/utils'

const profile = new ProfileApis()
export default {
  data() {
    return {
      convertSecondsToMinutes,
      otpLoading: false,
      otpResendTimer: 0,
      pending: false,
      form: {
        password: '',
        password_confirmation: '',
        otp_code: '',
      },
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      pendingTwoFactor: false,
      pendingReSendOtp: false,
      pendingOTP: false,
      reSendBtn: false,
    }
  },
  computed: {
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
  },
  methods: {
    async sendOtp() {
      this.otpLoading = true
      await profile.sendOtp().then(res => {
        this.otpResendTimer = res.data.results.remained_time
        this.countDownResetOtp()
      }).catch((err => {
        this.otpResendTimer = err.data.results.remained_time
        this.countDownResetOtp()
      })).finally(() => {
        this.otpLoading = false
      })
    },
    async save() {
      const success = await this.$refs.form.validate()
      if (success) {
        this.pending = true
        await profile.tradingPassword(this.form).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.form = {
            password: '',
            password_confirmation: '',
            otp_code: '',
          }
          this.$refs.form.reset()
        }).finally(() => {
          this.pending = false
          this.otpResendTimer = 0
        })
      }
    },
    countDownResetOtp() {
      setTimeout(() => {
        this.otpResendTimer -= 1
        if (this.otpResendTimer > 0) {
          this.countDownResetOtp()
        }
      }, 1000)
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
  },
}
